export type Locale='tr'|'en';export type DictionaryLocale=Locale;
export const DEFAULT_LOCALE:Locale='tr';
export function isSupportedLocale(v:unknown):v is Locale{return v==='tr'||v==='en';}
export function resolveDictionaryLocale(v:unknown):Locale{return v==='en'?'en':'tr';}
